import * as React from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../store'

const TrebleClef = () => {
  const themeState = useSelector((state: State) => state.root.theme)
  const clefState = useSelector((state: State) => state.root.theme.clef)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="20 4 55.115 145.12"
      style={{
        height: 0.9 * (clefState.lineSpace + clefState.lineThinkness) * 8 + 'px',
        position: 'absolute',
        top: '28px',
      }}
    >
      <path
        // stroke={themeState.note.color}
        fill={themeState.note.color}
        d="M51.688 5.25c-5.427-.14-11.774 12.818-11.563 24.375.049 3.52 1.16 10.659 2.781 19.625-10.223 10.581-22.094 21.44-22.094 35.688-.163 13.057 7.817 29.692 26.75 29.532 2.906-.02 5.521-.38 7.844-1 1.731 9.49 2.882 16.98 2.875 20.44.061 13.64-17.86 14.99-18.719 7.15 3.777-.13 6.782-3.13 6.782-6.84 0-3.79-3.138-6.88-7.032-6.88-2.141 0-4.049.94-5.343 2.41-.03.03-.065.06-.094.09-.292.31-.538.68-.781 1.1-.798 1.35-1.316 3.29-1.344 6.06 0 11.42 28.875 18.77 28.875-3.75.045-3.03-1.258-10.72-3.156-20.41 20.603-7.45 15.427-38.04-3.531-38.184-1.47.015-2.887.186-4.25.532a1412.774 1412.774 0 0 1-3.032-14.876C53.855 53.241 60.141 44.088 60 27.219c.022-12.114-4.014-21.828-8.312-21.969zm1.281 11.719c2.456-.237 4.406 2.043 4.406 7.062.199 8.62-5.84 16.148-13.031 23.719-.688-4.147-1.139-7.507-1.188-9.5.204-13.466 5.719-20.886 9.813-21.281zM45.25 61.656c.877 4.515 1.824 9.272 2.781 14.063-12.548 4.464-18.57 21.954-.781 29.781-10.843-9.231-5.506-20.158 2.312-22.062 1.966 9.816 3.886 19.502 5.438 27.872-2.107.74-4.566 1.17-7.438 1.19-7.181 0-21.531-4.57-21.531-21.875 0-14.494 10.047-20.384 19.219-28.969zm6.094 21.469c.313-.019.652-.011.968 0 13.063 0 17.99 20.745 4.688 27.375-1.655-8.32-3.662-17.86-5.656-27.375z"
      />
    </svg>
  )
}
export default TrebleClef
